import { connect } from 'react-redux'
import TableView from '../../../../common/containers/TableView'
import { useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { useSearchParams } from 'react-router-dom'
import { callCheckInitializeListGet, callCheckInitializePost } from '../../actions/check-initialize'
import Swal from 'sweetalert2'
import moment from 'moment'
import { toast } from 'react-toastify'

let CheckInitializePendingList = ({ setPageAttr, list, methods: { callCheckInitializeListGet, callCheckInitializePost } }) => {
    let [searchParams] = useSearchParams();
    let initialized = list.initialized

    const changeStatus = (a) => {
        Swal.fire({
            title: 'Confirme o status operacional deste local!\n(' + a.code + ' - ' + a.name + ')',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Ativo',
            denyButtonText: `Inativo`,
        }).then(async (result) => {
            let status, reason
            if (result.isConfirmed) {
                status = "active"
            } else if (result.isDenied) {
                status = "inactive"

                const { value: v } = await Swal.fire({
                    input: 'textarea',
                    inputLabel: 'Motivo',
                    inputPlaceholder: 'Digito o motivo do status inativo...',
                    inputAttributes: {
                        'aria-label': 'Escreva aqui...'
                    },
                    showCancelButton: false
                })

                if (!v){
                    toast.error('Informe um motivo do status inativo!')
                    return
                }

                reason = v
                    
            } else {
                return
            }

            callCheckInitializePost({
                location_id: a.id,
                status: status,
                reason: reason
            }, () => {
                let pg = searchParams.get('pg')
                pg = pg ? pg : 1
                callCheckInitializeListGet({
                    pending: 1,
                }, pg)
            })
        })
    }

    const headers = [
        {
            type: 'info',
            name: 'id',
            align: 'right',
            label: 'ID'
        },
        {
            type: 'info',
            name: 'company',
            align: 'left',
            label: 'Empresa'
        },
        {
            type: 'info',
            name: 'region',
            align: 'left',
            label: 'Região'
        },
        {
            type: 'info',
            name: 'code',
            align: 'right',
            label: 'Código'
        },
        {
            type: 'info',
            name: 'name',
            align: 'left',
            label: 'Nome'
        },
        {
            type: 'info',
            name: 'category',
            align: 'left',
            label: 'Categoria'
        },
        {
            type: 'custom',
            align: 'right',
            label: 'Opções',
            custom: (a) => {
                return (
                    <>
                        <span className='btn btn-sm btn-secondary ml-2' onClick={() => changeStatus(a)}><i className='fas fa-check'></i></span>
                    </>
                )
            }
        }
    ]

    useEffect(() => {
        let pg = searchParams.get('pg')
        pg = pg ? pg : 1
        callCheckInitializeListGet({
            pending: 1
        }, pg)
    }, [callCheckInitializeListGet, searchParams])

    useEffect(() => {
        let labelInfo = 'Iniciei a checagem'
        if (initialized) {
            labelInfo = 'Iniciado em: ' + moment(initialized.replace(/T/igm, ' ').replace(/Z/igm, '')).format("DD/MM/YYYY HH:mm")
        }
        setPageAttr({
            title: 'Checks Operacionais - Pendentes',
            caption: 'Marque o status dos locais informados até finalização da lista',
            btns: [
                {
                    type: 'info',
                    class: 'btn btn-warning',
                    label: labelInfo,
                }
            ],
            tabs: [
                {
                    active: true,
                    to: '/checks-initialize',
                    label: 'Pendentes'
                },
                {
                    active: false,
                    to: '/checks-initialize/finished',
                    label: 'Útimos Finalizados'
                }
            ]
        })
    }, [setPageAttr, initialized])

    return (
        <TableView headers={headers} rows={list.rows} total={list.total} pagination={list.pagination} paginationTo={'/checks-initialize'} />
    )
}

const mapStateToProps = ({ check: { checkInitialize: { list } } }) => ({
    list: list,
});

const mapDispatchToProps = (dispatch) => ({
    methods: bindActionCreators(
        {
            callCheckInitializeListGet,
            callCheckInitializePost
        },
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckInitializePendingList)